import * as yup from 'yup'
import { PersonDto } from './personDto'

export class VehicleImporterNoteDto {
  id?: string = undefined
  note?: string = undefined
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
}

export const VehicleImporterNoteValidationSchema = yup.object({
  note: yup.string().max(200, 'Importer Notes cannot be more than 200 characters').nullable()
})
